import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import s from './CustomSearchDropdownAndTextField.module.css';
import classnames from 'classnames';

type ItemType = {
    name: string;
    value: string;
    currency?: string;
};

type PropsType = {
    items: ItemType[];
    isError?: string;
    setCountryError?: any;
    placeholder?: string;
    id: string;
    name: string;
    touched?: boolean;
    customId?: string;
    setCurrency?: Dispatch<SetStateAction<string>>;
};

const CustomSearchDropdownAndTextField = (props: PropsType) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const { setFieldValue } = useFormikContext();
    const [field] = useField<ItemType>(props.name);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            const container = document.getElementById(props.id);
            if (container && !container.contains(e.target as Node)) {
                setIsDropdownVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [props.id]);

    useEffect(() => {
        if (field.value?.name) {
            setInputValue(field.value.name);
        }
    }, [field.value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);
        setIsDropdownVisible(true);
    };

    const handleItemSelect = (item: ItemType) => {
        setFieldValue(props.name, item);
        setInputValue(item.name);
        setIsDropdownVisible(false);
        if (props.setCurrency) {
            props.setCurrency(item.currency || '');
        }
    };

    const handleBlur = () => {
        setIsDropdownVisible(false);
        const existing = props.items.find(
            (item) => item.name.toLowerCase() === inputValue.toLowerCase()
        );
        if (!existing && inputValue.trim() !== '') {
            const newItem = {
                name: inputValue.trim(),
                value: inputValue.trim()
            };
            setFieldValue(props.name, newItem);
        }
    };

    const filteredItems = props.items.filter(
        (item) =>
            item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            item.value.toLowerCase().includes(inputValue.toLowerCase())
    );

    useEffect(() => {
        if (field.value?.value) {
            setInputValue(field.value.value);
        }
    }, [field.value]);

    return (
        <div className={s.phoneInputWrapper} id={props.id}>
            <div className={s.inputWrapper}>
                <input
                    className={classnames(s.my_input, {
                        [s.error]: props.isError && props.touched,
                    })}
                    name={props.name}
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onFocus={() => setIsDropdownVisible(true)}
                    onBlur={handleBlur}
                    placeholder={props.placeholder}
                    autoComplete="off"
                />
            </div>

            {isDropdownVisible && (
                <div className={s.optionsWrapper}>
                    {filteredItems.map((item, index) => (
                        <div
                            key={index}
                            className={s.option}
                            onMouseDown={() => handleItemSelect(item)} 
                        >
                            <div className={s.countryName}>
                                {item.name} : {item.value}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSearchDropdownAndTextField;
